<script>
  import Navbar from "./components/navbar.svelte";
  import Slot from "./components/slot.svelte";
  import router from "page";
  import { routes } from "./utils/routes";
  import { pathParam, scroll } from "./store/parallax";
  import { black } from "./utils/colors";
  import { fade, slide, blur, crossfade, draw, fly } from "svelte/transition";

  let page;
  let params;
  let path;
  let y;

  routes.map((route) => {
    router(
      route.path,
      (ctx, next) => {
        params = ctx.params;
        next();
      },
      () => {
        page = route.component;
        path = route.path
      }
    );
  });
  router.start();

  $: {
    scroll.set(y);
    pathParam.set(path)
    // console.log(y);
    // console.log($scroll);
  }
</script>

<svelte:window bind:scrollY={y} />

<main class="">
  <Navbar />
  <div transition:fade>
    <Slot refresh={$pathParam}>
      <svelte:component this={page} {params} />
    </Slot>
  </div>
</main>
